// extracted by mini-css-extract-plugin
module.exports = {"LeftSettingPart":"LeftSettingPart_LeftSettingPart___9Gvf"};